/** `#RRGGBB`, mayúsculas o minúsculas. Sin alpha, sin forma corta. */
const HEX_DE_SEIS = /^#[0-9a-f]{6}$/i;

export function esHex(valor: string): boolean {
  return HEX_DE_SEIS.test(valor);
}

/**
 * `#1644EB` → `"22 68 235"`: el triple que va en `--brand-primary-rgb`, para que la
 * opacidad se escriba `rgb(var(--brand-primary-rgb) / 0.1)` y siga al branding igual que
 * el color sólido.
 */
export function hexARgbTriple(hex: string): string {
  if (!esHex(hex)) throw new Error(`No es un hex de seis dígitos: ${hex}`);
  const n = parseInt(hex.slice(1), 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}
